import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ChatBot.css";
import Sidebar from "../Sidebar/Sidebar";
import AdminNavbar from "../AdminNavbar/AdminNavbar";
const apiUrl = process.env.REACT_APP_API_BASE_URL;


const API_BASE_URL = `${apiUrl}/api/chat`;

function ChatBot() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");

  useEffect(() => {
    axios.get(`${API_BASE_URL}`)
      .then((response) => {
        console.log("Users Data:", response.data);
        setUsers(response.data);
      })
      .catch((error) => console.error("Error fetching users:", error));
  }, []);

  useEffect(() => {
    if (selectedUser) {
      fetchMessages();
      const interval = setInterval(fetchMessages, 3000);
      return () => clearInterval(interval);
    }
  }, [selectedUser]);

  const fetchMessages = async () => {
    if (!selectedUser || !selectedUser.userId) return;
    try {
      const response = await axios.get(`${API_BASE_URL}/${selectedUser.userId._id}`);
      setMessages(response.data.messages);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const selectUser = async (user) => {
    if (!user.userId) {
      console.error("Invalid user object:", user);
      return;
    }
    setSelectedUser(user);
    await fetchMessages();
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!inputMessage.trim() || !selectedUser || !selectedUser.userId) return;

    const messageData = {
      userId: selectedUser.userId._id,
      text: inputMessage,
    };

    try {
      await axios.post(`${API_BASE_URL}/reply`, messageData);
      setMessages((prev) => [...prev, { sender: "admin", text: inputMessage }]);
      setInputMessage("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  return (
    <div className="main-dashboard">
      <Sidebar />
      <div className="dashboard">
        <AdminNavbar />
        <div className="admin-chat-container">
          <div className="user-list">
            <h2>Users</h2>
            {users.length === 0 ? (
              <p>No users found</p>
            ) : (
              users.map((user) => (
                <div key={user._id} onClick={() => selectUser(user)} className="user-item">
                  {user.userId ? `${user.userId.name} (${user.userId.email})` : "Unknown User"}
                </div>
              ))
            )}
          </div>

          <div className="chat-box">
            {selectedUser ? (
              <>
                <h2>Chat with {selectedUser.userId?.name || "Unknown User"}</h2>
                <div className="messages">
                  {messages.map((msg, index) => (
                    <div key={index} className={msg.sender === "admin" ? "admin-msg" : "user-msg"}>
                      {msg.text}
                    </div>
                  ))}
                </div>
                <form onSubmit={sendMessage} className="input-container">
                  <input
                    type="text"
                    value={inputMessage}
                    onChange={(e) => setInputMessage(e.target.value)}
                    placeholder="Type a message..."
                  />
                  <button type="submit">Send</button>
                </form>
              </>
            ) : (
              <h2>Select a user to chat</h2>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatBot;